import { useQuery } from '@tanstack/react-query';
import { fetchRapidFireReattempts } from '../services/subscriptionService';

export function useRapidFireReattempts() {
  return useQuery({
    queryKey: ['rapidFireReattempts'],
    queryFn: async () => {
      const data = await fetchRapidFireReattempts();
      return {
        remainingAttempts: Number(data.remaining_attempts || 0),
        packs: (Array.isArray(data.plans) ? data.plans : [])
          .map((plan) => ({ ...plan, attempt_label: plan.attempts_label })),
      };
    },
    staleTime: 0,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnMount: 'always',
  });
}
